/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooter
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooter {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooter
     */
    value?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooterFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooter {
    return JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooterFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooterFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooterToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldFooter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

